/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import './text-input.scss';
import './modifiers/text-input-background.scss';
import './modifiers/text-input-state-error.scss';
import './modifiers/text-input-state-password.scss';
